import React from "react";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";
import InventoryList from "../../../components/screen/inventory/InventoryList";

const InventoryPage = ({ isWarehouse }) => {
  return (
    <PageTemplate
      header={"Inventory " + (isWarehouse ? "Central Warehouse" : "")}
      mainComponent={
        <ThemeProvider theme={theme}>
          <div className="text-[12px]">
            <InventoryList isWarehouse={isWarehouse ? isWarehouse : false} />
          </div>
        </ThemeProvider>
      }
      pageRole={2}
    />
  );
};

export default HOC(InventoryPage);
